(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4349],{

/***/ 16563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Clients; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Clients/Clients.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Wrapper",
  componentId: "sc-1992s35-0"
})(["padding-top:", ";background:rgba(116,120,129,0.08);position:relative;@media (min-width:", "px){padding-top:", ";padding-bottom:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40));
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Section",
  componentId: "sc-1992s35-1"
})(["display:flex;flex-direction:column;padding:", " 0 ", " 0;@media (min-width:", "px){flex-direction:row;}@media (min-width:", "px){align-items:center;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Reviews = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Reviews",
  componentId: "sc-1992s35-2"
})([""]);
var Review = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Review",
  componentId: "sc-1992s35-3"
})(["&.isVisible{display:block;}&.isHidden{display:none;}"]);
var ReviewText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Clientselements__ReviewText",
  componentId: "sc-1992s35-4"
})(["margin:0;font-size:", ";line-height:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryGrey;
});
var ReviewAuthor = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Clientselements__ReviewAuthor",
  componentId: "sc-1992s35-5"
})(["font-weight:", ";color:", ";line-height:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(24));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Clientselements__Image",
  componentId: "sc-1992s35-6"
})(["height:auto;border-radius:", ";margin-bottom:", ";margin-left:", ";min-width:300px;@media (min-width:", "px){width:55%;margin-right:5%;max-width:360px;}"], (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(-30), theme/* breakpoints.sm */.A.sm);
var Slider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Slider",
  componentId: "sc-1992s35-7"
})(["width:100%;background:", ";padding:", " 0;display:flex;justify-content:center;@media (min-width:", "px){justify-content:flex-end;margin-top:", ";z-index:99;position:relative;background:transparent;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(-110));
var SliderButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Clientselements__SliderButton",
  componentId: "sc-1992s35-8"
})(["background:none;border:none;cursor:pointer;svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__About",
  componentId: "sc-1992s35-9"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(100));
var AboutDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Clientselements__AboutDescription",
  componentId: "sc-1992s35-10"
})(["font-size:", ";line-height:", ";color:", ";text-align:center;@media (min-width:", "px){width:75%;margin:", " auto 0 auto;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(-20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Clients/Clients.tsx














var REFERENCES = [{
  company: 'Kancelária NR SR',
  name: 'M. Kiklicová',
  comment: 'Pekný deň, zúčastnila som sa i tohto ročníka Konferencie z pracovného práva a personalistiky 2026. Veľmi rada konštatujem, že tak, ako i po iné roky, i tento ročník bol zorganizovaný na vysokej profesionálnej úrovni. Obsahom konferencie boli zaujímavé a aktuálne témy a som rada, že ako rečníci vystúpili na slovo vzatí odborníci z oblasti pracovného práva, za ktorých považujem najmä pána Tomana a Dolobáča. Zaujímaví boli i ostatní hostia a témy, najmä AI a HR. Dozvedeli sme sa z konferencie zaujímavosti, ktoré sú pre nás inšpiratívne (najmä v oblasti používania AI v HR) ako i témy, pri ktorých môžeme tíško závidieť (benefity pre zamestnancov – pani Horvátová z KIA Slovakia). Už teraz sa budeme tešiť na ďalší ročník a zaujímavých hostí. Ďakujem krásne.'
}, {
  company: 'Humanus, n.o.',
  name: 'M. Muziková',
  comment: 'Dobrý deň, chcem sa poďakovať za školenie „Novela zákona o sociálnych službách od 1. 7. 2026: praktický prehľad zmien pre obce a poskytovateľov“. Pani lektorka Ivana Kružliaková bola úžasná. Boli podané veľmi konkrétne informácie v maximálne zrozumiteľnej, jednoduchej forme. Bola som nadšená. Ďakujem aj za materiál, určite ich využijem pri mojej práci.'
}, {
  company: 'Univerzitná nemocnica Bratislava',
  name: 'PhDr. Tatiana Štihová',
  comment: 'Sama som absolvovala už niekoľko rôznych seminárov, ktoré organizovali iné spoločnosti, avšak prvýkrát bol seminár na&nbsp;vysokej odbornej úrovni. Celý deň nás prostredníctvom názorných ukážok spracovaných v&nbsp;PowerPointe sprevádzala erudovaná lektorka pani Ing. Oxana Hospodárová. Na&nbsp;takmer všetky otázky našla odpovede a vedela poradiť aj praktickými riešeniami priamo z&nbsp;praxe a bežného života. Pohodu na&nbsp;seminári dotvorilo aj príjemné a elegantné prostredie hotela Saffron, milý a ochotný personál. Ďakujem organizátorom za&nbsp;príjemný zážitok. Odporúčam účasť na&nbsp;uvedenom seminári.'
}, {
  company: 'Brantner Nova, s.r.o',
  name: 'Anastázia Sedláková',
  comment: 'Dobrý deň, dovoľte mi, prosím, poďakovať sa Vám, za možnosť po mnohých rokoch sa vrátiť na niekoľko dní do Prahy ako výherca v tombole na konferencii Daňový a odvodový kolotoč v Starom Smokovci – pobyt pre dvoch v hoteli Absolutum. Pobyt sme s manželom absolvovali v júni 2024 a veľmi sme si vychutnali toto krásne mesto. Ďakujeme Vám veľmi pekne.'
}, {
  company: 'Účtovníctvo Zuzana s. r. o.',
  name: 'Ing. Zuzana Blahová',
  comment: 'Semináre Poradcu podnikateľa sú vynikajúce najmä pre&nbsp;profesionálnych účtovníkov. Témy a lektori seminárov sú výborne zvolení a na&nbsp;každom seminári som dostala viac informácií, ako som očakávala. Som veľmi spokojná.'
}, {
  company: 'WEBY GROUP, s.r.o.',
  name: 'Miriam Surová',
  comment: 'Rada by som Vám touto cestou chcela poďakovať za&nbsp;zrealizovanie konferencie formou živého prenosu. Konferencie sme sa zúčastnili aj v&nbsp;minulom roku a dovolím si napísať vyjadrenie, že tento ročník mal prednášajúcich aj prednášky na&nbsp;vysokej odbornej, ale aj zrozumiteľnej úrovni. Moderovaná diskusia bola prínosom určite pre&nbsp;všetkých zúčastnených. Sami sme si z&nbsp;nej odniesli zodpovedané otázky. Tešíme sa na&nbsp;ďalší ročník. Verím, že sa ho zúčastníme osobne. Prajem Vám príjemný a úspešný deň.'
}, {
  company: 'BYTTERM, a.s. Žilina',
  name: 'Dana Pudíková',
  comment: 'Na&nbsp;základe toho, že od&nbsp;Vás pravidelne dostávam ponuky a zároveň aj prehľad školení, chcela by som sa poďakovať za&nbsp;túto službu. Už niekoľkokrát som sa týchto školení zúčastnila a bola som milo prekvapená, že si stačilo vyznačiť školenie, o&nbsp;ktoré som mala záujem, a následne mi bola zaslaná faktúra, čím bolo potvrdené, že všetko ostatné je zabezpečené vždy pre&nbsp;moju spokojnosť a aj spokojnosť ostatných kolegýň.'
}, {
  company: 'FO',
  name: 'Dušan Peško',
  comment: 'Absolvoval som niekoľko školení na&nbsp;tému GDPR, ale s&nbsp;vaším som bol najviac spokojný. Výklad lektorky JUDr. Macovej bol obsahovo kompaktný, zameraný na&nbsp;podstatné veci, vhodne doplnený praktickými radami a príkladmi z&nbsp;praxe. Váš kurz mal pre&nbsp;mňa najväčší úžitok.'
}, {
  company: 'Stredisko sociálnych služieb Petržalka',
  name: 'PhDr. Irena Tatranská',
  comment: 'Z&nbsp;vydavateľského a vzdelávacieho domu Poradca podnikateľa odoberáme časopisy Dane a Účtovníctvo; Práca, mzdy a odmeňovanie a Finančného spravodajcu. Zúčastňujeme sa školení. S&nbsp;kvalitou časopisov sme spokojní, mesačníky informujú v&nbsp;priebehu roka o&nbsp;aktuálnych témach, venujú sa výkladu noviel zákonov, obsahujú prehľady – kalendár zákonných povinností na&nbsp;príslušný kalendárny mesiac, kurzy, vyhľadávač. Štruktúra časopisov je prehľadná, obsahuje veľa príkladov z&nbsp;praxe. Školenia sú lektorované profesionálne, vždy so študijným materiálom, prebiehajú v&nbsp;príjemnej atmosfére. Spolupráca s&nbsp;vydavateľstvom je operatívna.'
}, {
  company: 'Contineo, s. r. o.',
  name: 'Marcela Peterčáková',
  comment: 'Pani JUDr. Macová bola neskutočná, podala toľko zaujímavých informácií, že ešte dnes, deň po&nbsp;školení, mám pocit, že som v&nbsp;aule... Chcela by som vysloviť veľké ĎAKUJEM a teším sa na&nbsp;budúce školenia. Prajem veľa profesionálnych úspechov.'
}, {
  company: 'KraussMaffei Technologies, spol. s r.o.',
  name: 'Jana Dologová',
  comment: 'Službu Ročné Profivzdelávanie využívame v&nbsp;našej spoločnosti už takmer rok a bez&nbsp;váhania sme sa rozhodli predplatiť si ju aj na&nbsp;ten nasledujúci. Ponuka webinárov je naozaj veľmi zaujímavá, oslovila kolegov z&nbsp;rôznych oddelení, napr. HR, finančné, priemyselné inžinierstvo. Pravidelne dostávam e-mailovú notifikáciu o&nbsp;konaní webinárov, ktorú následne prepošlem podľa záujmu konkrétnym zamestnancom. Vzhľadom na&nbsp;pracovnú vyťaženosť veľmi oceňujeme možnosť pozrieť si webinár zo&nbsp;záznamu.'
}];

var ClientsTemplate = function ClientsTemplate(_ref) {
  var titleKey = _ref.titleKey;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(0),
      visibleKey = _useState[0],
      setVisibleKey = _useState[1];

  (0,useScrollToSection/* default */.Z)('referencie', 'referencesId');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
        mobileSidePadding: 20,
        id: "referencesId",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
          alignCenter: true,
          tagType: Title/* TitleTagTypes.H3 */.Z.H3,
          isBlack: true,
          children: t(titleKey)
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
            src: (0,url_utils/* publicAssets */.VK)('/clients.webp')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Reviews, {
            children: REFERENCES.map(function (reference, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Review, {
                className: key === visibleKey ? 'isVisible' : 'isHidden',
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReviewText, {
                  dangerouslySetInnerHTML: {
                    __html: reference === null || reference === void 0 ? void 0 : reference.comment
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReviewAuthor, {
                  children: [reference === null || reference === void 0 ? void 0 : reference.name, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", reference === null || reference === void 0 ? void 0 : reference.company]
                })]
              }, key);
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Slider, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderButton, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: visibleKey > 0 ? Icon/* Icons.ArrowCircleLeftActive */.PJ.ArrowCircleLeftActive : Icon/* Icons.ArrowCircleLeftDisabled */.PJ.ArrowCircleLeftDisabled,
            onClick: function onClick() {
              return setVisibleKey(visibleKey > 0 ? visibleKey - 1 : 0);
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderButton, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: visibleKey < REFERENCES.length - 1 ? Icon/* Icons.ArrowCircleRightActive */.PJ.ArrowCircleRightActive : Icon/* Icons.ArrowCircleRightDisabled */.PJ.ArrowCircleRightDisabled,
            onClick: function onClick() {
              return setVisibleKey(visibleKey < REFERENCES.length - 1 ? visibleKey + 1 : visibleKey);
            }
          })
        })]
      })
    }), router.pathname === constants/* ROUTES.HOME */.Z6.HOME && /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
          isBlack: true,
          alignCenter: true,
          children: t('clients.label')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AboutDescription, {
          children: t('clients.description')
        })]
      })
    })]
  });
};

/* harmony default export */ var Clients = (ClientsTemplate);

/***/ }),

/***/ 91149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Faqs; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Faqs/Faqs.elements.tsx




var Transportation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__Transportation",
  componentId: "sc-7m7y6v-0"
})(["display:flex;flex-direction:column;margin:", " 0;padding:", ";@media (min-width:", "px){flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var TransportationOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationOptions",
  componentId: "sc-7m7y6v-1"
})(["width:100%;padding:", " 0;@media (min-width:", "px){width:65%;}"], (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md);
var TransportationOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationOption",
  componentId: "sc-7m7y6v-2"
})([""]);
var TransportationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationHeader",
  componentId: "sc-7m7y6v-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:", " 0;border-bottom:1px solid ", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
});
var TransportationHeaderTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Faqselements__TransportationHeaderTitle",
  componentId: "sc-7m7y6v-4"
})(["font-size:", ";&.isOpen{color:", ";}"], (0,polished_esm/* rem */.hO)(18), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
});
var TransportationHeaderIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "Faqselements__TransportationHeaderIcon",
  componentId: "sc-7m7y6v-5"
})(["svg{width:", ";height:", ";}&.isOpen{svg{transform:rotate(180deg);}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Faqselements__TransportationDescription",
  componentId: "sc-7m7y6v-6"
})(["padding:", " 0;line-height:", ";.withBorder{text-decoration:underline;display:block;padding:", " 0;}.question{text-decoration:underline;}li{margin:", " 0;}a{color:", ";text-decoration:underline;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(5), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Faqs/Faqs.tsx











var ABOUT_QUESTIONS = [{
  id: 1,
  question: 'about.faq.question1.title',
  answer: 'about.faq.question1.answer.question1'
}, {
  id: 2,
  question: 'about.faq.question2.title',
  answer: 'about.faq.question2.answer.question1'
}, {
  id: 3,
  question: 'about.faq.question3.title',
  answer: 'about.faq.question3.answer.question1'
}, {
  id: 4,
  question: 'about.faq.question4.title',
  answer: 'about.faq.question4.answer.question1'
}, {
  id: 5,
  question: 'about.faq.question5.title',
  answer: 'about.faq.question5.answer.question1'
}, {
  id: 6,
  question: 'about.faq.question6.title',
  answer: 'about.faq.question6.answer.question1'
}];
var SUBSCRIPTION_QUESTIONS = [{
  id: 1,
  question: 'subscription.question1.question',
  answer: 'subscription.question1.answer'
}, {
  id: 2,
  question: 'subscription.question2.question',
  answer: 'subscription.question2.answer'
}, {
  id: 3,
  question: 'subscription.question3.question',
  answer: 'subscription.question3.answer'
}, {
  id: 4,
  question: 'subscription.question4.question',
  answer: 'subscription.question4.answer'
}, {
  id: 5,
  question: 'subscription.question5.question',
  answer: 'subscription.question5.answer'
}, {
  id: 6,
  question: 'subscription.question6.question',
  answer: 'subscription.question6.answer'
}, {
  id: 7,
  question: 'subscription.question7.question',
  answer: 'subscription.question7.answer'
}, {
  id: 8,
  question: 'subscription.question8.question',
  answer: 'subscription.question8.answer'
}, {
  id: 9,
  question: 'subscription.question9.question',
  answer: 'subscription.question9.answer'
}, {
  id: 10,
  question: 'subscription.question10.question',
  answer: 'subscription.question10.answer'
}];
var DEFAULT_OPENED_KEY = 'ako-prebieha-online-skolenie';

var FaqsTemplate = function FaqsTemplate() {
  var _ABOUT_QUESTIONS$;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(router.asPath.includes(DEFAULT_OPENED_KEY) ? [(_ABOUT_QUESTIONS$ = ABOUT_QUESTIONS[0]) === null || _ABOUT_QUESTIONS$ === void 0 ? void 0 : _ABOUT_QUESTIONS$.id] : []),
      openedAreas = _useState[0],
      setOpenedAreas = _useState[1];

  (0,useScrollToSection/* default */.Z)(DEFAULT_OPENED_KEY, DEFAULT_OPENED_KEY, 250);

  var toggleTransportationOption = function toggleTransportationOption(option) {
    if (openedAreas.includes(option)) {
      setOpenedAreas([]);
    } else {
      setOpenedAreas([]);
      setTimeout(function () {
        window.scrollTo({
          top: document.getElementById("".concat(option)).offsetTop - 150,
          behavior: 'smooth'
        });
        setOpenedAreas([option]);
      }, 50);
    }
  };

  (0,useScrollToSection/* default */.Z)('faqs', 'faqsId');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    mobileSidePadding: 20,
    id: "faqsId",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Transportation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        alignLeft: true,
        isBlack: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          dangerouslySetInnerHTML: {
            __html: t(router.pathname.includes(constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION) ? 'subscription.faq.title' : 'about.faq.title')
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationOptions, {
        children: (router.pathname.includes(constants/* ROUTES.ABOUT_US */.Z6.ABOUT_US) ? ABOUT_QUESTIONS : SUBSCRIPTION_QUESTIONS).map(function (area, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
              id: "".concat(area.id),
              onClick: function onClick() {
                return toggleTransportationOption(area.id);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                children: t(area.question)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
              })]
            }), openedAreas.includes(area.id) && /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationDescription, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: t(area.answer)
                }
              })
            })]
          }, key);
        })
      })]
    })
  });
};

/* harmony default export */ var Faqs = (FaqsTemplate);

/***/ }),

/***/ 59922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49642);





var useScrollToSection = function useScrollToSection(sectionNameInPathname, sectionIdInHtml, spacing) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.asPath.includes(sectionNameInPathname)) {
      var element = document.getElementById(sectionIdInHtml);
      return window.scrollTo({
        top: element.offsetTop - (window.innerWidth > _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.sm */ .A.sm ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .DESKTOP_HEADER_HEIGHT */ .cf : _constants__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_HEADER_HEIGHT */ .ZQ) - (spacing || 0),
        behavior: 'smooth'
      });
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToSection);

/***/ }),

/***/ 52512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ o_nas; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Clients/Clients.tsx + 1 modules
var Clients = __webpack_require__(16563);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CompanyValues/CompanyValues.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__Wrapper",
  componentId: "sc-1yc5dv8-0"
})(["margin-top:", ";padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Sections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__Sections",
  componentId: "sc-1yc5dv8-1"
})(["font-size:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:45%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__Section",
  componentId: "sc-1yc5dv8-2"
})(["margin-bottom:", ";", ";", ";", ";"], (0,polished_esm/* rem */.hO)(40), function (prop) {
  return prop.isMission ? "border: 1px solid ".concat(prop.theme.colors.border) : '';
}, function (prop) {
  return prop.isMission ? "border-radius: ".concat((0,polished_esm/* rem */.hO)(16)) : '';
}, function (prop) {
  return prop.isMission ? "padding: ".concat((0,polished_esm/* rem */.hO)(20), " ").concat((0,polished_esm/* rem */.hO)(10)) : '';
});
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__SectionHeader",
  componentId: "sc-1yc5dv8-3"
})(["display:flex;flex-direction:row;align-items:center;font-weight:", ";font-family:", ";", ";", ";svg{margin-right:", ";width:", ";height:", ";path{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.isMission ? "color: ".concat(prop.theme.colors.primary) : '';
}, function (prop) {
  return prop.isMission ? "padding-left: ".concat((0,polished_esm/* rem */.hO)(25)) : '';
}, (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(24), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyValueselements__SectionDescription",
  componentId: "sc-1yc5dv8-4"
})(["padding-top:", ";margin-left:", ";color:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CompanyValues/CompanyValues.tsx










var CompanyValuesTemplate = function CompanyValuesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('about.companyValues.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section1.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section1.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section2.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section2.description')
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('about.companyValues.section4.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section4.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          isMission: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionHeader, {
            isMission: true,
            children: t('about.companyValues.section6.label')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('about.companyValues.section6.description')
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var CompanyValues = (CompanyValuesTemplate);
// EXTERNAL MODULE: ./src/components/Faqs/Faqs.tsx + 1 modules
var Faqs = __webpack_require__(91149);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/dist/index.es.js
var index_es = __webpack_require__(92879);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(23955);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.elements.tsx



var Gallery_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__Wrapper",
  componentId: "sc-14sd62t-0"
})(["position:relative;padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Main = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__Main",
  componentId: "sc-14sd62t-1"
})(["display:flex;align-items:center;justify-content:center;flex-wrap:wrap;"]);
var PicWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__PicWrapper",
  componentId: "sc-14sd62t-2"
})(["margin:", ";width:80%;@media (min-width:", "px){width:40%;}@media (min-width:", "px){width:30%;}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md, theme/* breakpoints.lg */.A.lg);
var PicSource = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Galleryelements__PicSource",
  componentId: "sc-14sd62t-3"
})(["width:100%;cursor:pointer;border-radius:", ";"], (0,polished_esm/* rem */.hO)(14));
var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__Background",
  componentId: "sc-14sd62t-4"
})(["width:100%;height:", ";top:0;left:0;background:rgba(116,120,129,0.08);position:absolute;z-index:-999;@media (min-width:", "px){height:", ";}"], (0,polished_esm/* rem */.hO)(300), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(500));
var Video = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__Video",
  componentId: "sc-14sd62t-5"
})(["width:100%;padding:", " 0 ", " 0;margin:0 auto ", " auto;@media (min-width:", "px){width:80%;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm);
var Player = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
  displayName: "Galleryelements__Player",
  componentId: "sc-14sd62t-6"
})(["width:100%;border-radius:", ";"], (0,polished_esm/* rem */.hO)(14));
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Galleryelements__ButtonWrapper",
  componentId: "sc-14sd62t-7"
})(["display:flex;justify-content:center;"]);
var Gallery_elements_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Galleryelements__Title",
  componentId: "sc-14sd62t-8"
})(["font-weight:", ";font-size:", ";width:100%;text-align:center;margin-top:", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(20));
;// CONCATENATED MODULE: ./src/components/Gallery/Gallery.tsx













var GalleryTemplate = function GalleryTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var Images = [(0,url_utils/* publicAssets */.VK)('/events1.jpg'), (0,url_utils/* publicAssets */.VK)('/events2.jpg'), (0,url_utils/* publicAssets */.VK)('/events3.jpg'), (0,url_utils/* publicAssets */.VK)('/events4.jpg'), (0,url_utils/* publicAssets */.VK)('/events5.jpg'), (0,url_utils/* publicAssets */.VK)('/events6.jpg'), (0,url_utils/* publicAssets */.VK)('/events7.jpg'), (0,url_utils/* publicAssets */.VK)('/events8.jpg'), (0,url_utils/* publicAssets */.VK)('/events9.jpg'), (0,url_utils/* publicAssets */.VK)('/events10.jpg'), (0,url_utils/* publicAssets */.VK)('/events11.jpg'), (0,url_utils/* publicAssets */.VK)('/events12.jpg'), (0,url_utils/* publicAssets */.VK)('/events13.jpg'), (0,url_utils/* publicAssets */.VK)('/events14.jpg'), (0,url_utils/* publicAssets */.VK)('/events15.jpg'), (0,url_utils/* publicAssets */.VK)('/events16.jpg'), (0,url_utils/* publicAssets */.VK)('/events17.jpg'), (0,url_utils/* publicAssets */.VK)('/events18.jpg'), (0,url_utils/* publicAssets */.VK)('/events19.jpg'), (0,url_utils/* publicAssets */.VK)('/events20.jpg')];

  var _useState = (0,react.useState)(false),
      showAll = _useState[0],
      setShowAll = _useState[1];

  var _useState2 = (0,react.useState)(false),
      imgFocus = _useState2[0],
      setImgFocus = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      imgIndex = _useState3[0],
      setImgIndex = _useState3[1];

  var minImgShowCount = 6;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery_elements_Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      mobileSidePadding: 20,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Background, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('about.gallery.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
        children: Images.map(function (img, index) {
          return showAll || index < minImgShowCount ? /*#__PURE__*/(0,jsx_runtime.jsx)(PicWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PicSource, {
              src: img,
              onClick: function onClick() {
                setImgIndex(index);
                setImgFocus(true);
              }
            })
          }, index) : null;
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: function onClick() {
            setShowAll(!showAll);
          },
          text: showAll ? t('about.gallery.showLess') : t('about.gallery.showMore'),
          whiteType: true
        })
      }), imgFocus && /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
        mainSrc: Images[imgIndex],
        nextSrc: Images[(imgIndex + 1) % Images.length],
        prevSrc: Images[(imgIndex + Images.length - 1) % Images.length],
        onCloseRequest: function onCloseRequest() {
          return setImgFocus(false);
        },
        onMovePrevRequest: function onMovePrevRequest() {
          return setImgIndex((imgIndex + Images.length - 1) % Images.length);
        },
        onMoveNextRequest: function onMoveNextRequest() {
          return setImgIndex((imgIndex + 1) % Images.length);
        }
      })]
    })
  });
};

/* harmony default export */ var Gallery = (GalleryTemplate);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/ui/Divider/Divider.tsx + 1 modules
var Divider = __webpack_require__(96770);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/pages/o-nas.tsx

















var AboutUs = function AboutUs() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.about.title'),
      description: t('seo.about.description'),
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK,
      openGraph: {
        images: [{
          url: "https://profivzdelavanie.sk".concat((0,url_utils/* publicAssets */.VK)('/og-konferencia.png'))
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "about.hero.title",
      imageKey: "about_hero.webp",
      descriptionKey: "about.hero.paragraph",
      withBenefits: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
      marginBottom: 20
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyValues, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {
      marginBottom: 20
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Clients/* default */.Z, {
      titleKey: 'about.clients.title'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var o_nas = (AboutUs);

/***/ }),

/***/ 96770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Dividerelements__Wrapper",
  componentId: "sc-1b0a3wd-0"
})(["height:1px;width:100%;background:", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, function (prop) {
  return prop.marginTop ? "margin-top: ".concat((0,polished_esm/* rem */.hO)(prop.marginTop)) : '';
}, function (prop) {
  return prop.marginBottom ? "margin-bottom: ".concat((0,polished_esm/* rem */.hO)(prop.marginBottom)) : '';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.tsx




var DividerTemplate = function DividerTemplate(_ref) {
  var marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    marginTop: marginTop,
    marginBottom: marginBottom
  });
};

/* harmony default export */ var Divider = (DividerTemplate);

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-1"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-2"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-3"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (props) {
  return props.withoutBottomPadding ? 0 : (0,polished_esm/* rem */.hO)(30);
}, theme/* breakpoints.md */.A.md, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-4"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Benefit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefit",
  componentId: "sc-1nsgps3-6"
})(["display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;width:50%;margin-bottom:", ";@media (min-width:", "px){width:25%;margin-bottom:0;}@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.lg */.A.lg);
var Benefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefits",
  componentId: "sc-1nsgps3-7"
})(["display:flex;justify-content:space-between;padding:0 0 ", " 0;flex-wrap:wrap;margin-top:", ";max-width:", ";margin:", " auto ", " auto;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(-40), (0,polished_esm/* rem */.hO)(40));
var BenefitNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitNumber",
  componentId: "sc-1nsgps3-8"
})(["font-size:", ";font-family:", ";font-weight:700;color:", ";padding-right:", ";white-space:nowrap;"], (0,polished_esm/* rem */.hO)(48), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSecondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(15));
var BenefitLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitLabel",
  componentId: "sc-1nsgps3-9"
})(["font-weight:", ";font-size:", ";text-align:center;line-height:", ";@media (min-width:", "px){text-align:left;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeights.textBold;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx










var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      listKeys = _ref.listKeys,
      descriptionKey = _ref.descriptionKey,
      withBenefits = _ref.withBenefits;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          dangerouslySetInnerHTML: {
            __html: t(titleKey)
          },
          withoutBottomPadding: (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && !!descriptionKey
        }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          dangerouslySetInnerHTML: {
            __html: t(descriptionKey)
          }
        }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: t(listKey)
              }
            })]
          }, key);
        }))]
      })]
    }), withBenefits && /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefits, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit1.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit2.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit3.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit4.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";", ";@media (min-width:", "px){font-size:", ";line-height:", ";", ";padding:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.$isBlack ? "color: ".concat(prop.theme.colors.black, ";") : "color: ".concat(prop.theme.colors.primary, ";");
}, function (prop) {
  return prop.$alignCenter ? 'text-align: center;' : '';
}, theme/* breakpoints.sm */.A.sm, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(44), function (prop) {
  return prop.$alignLeft ? 'text-align: left;' : 'text-align: center;';
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(15), " 0 ").concat((0,polished_esm/* rem */.hO)(60), " 0");
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      alignCenter = _ref.alignCenter,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    $withoutPadding: withoutPadding,
    $alignLeft: alignLeft,
    $alignCenter: alignCenter,
    $isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 6450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-nas",
      function () {
        return __webpack_require__(52512);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,9392,4623,9774,2888,179], function() { return __webpack_exec__(6450); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);